import { AppSettingService } from './app-setting.service';
import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Loginuser } from '../model/loginuser';
import { map } from 'rxjs/Operators';
import { HttpclientService } from '../services/httpclient.service';
import { environment } from 'src/environments/environment';
import { Enablesaveuseraccessdto } from '../model/enablesaveuseraccessdto';
import { EnvConfigService } from './env-config.service';


@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  status : boolean = false;

  evnValues;
  apiUrl;
  host;

  constructor(private httpClient: HttpClient, private httpClientService: HttpclientService, public appSettingService: AppSettingService,
              public envConfigService: EnvConfigService) {

                this.host = location.host;
                if ( this.host.includes('localhost') ) {
                  this.host = 'localhost:8090';
                }
                this.apiUrl = location.protocol + '//' + this.host + '/dashboard';
  //this.envConfigService.loadAppConfig();

               }

  authenticate(username, password) {
    const headers = new HttpHeaders({ Authorization: 'Basic ' + btoa(username + ':' + password) });
    return this.httpClient.get<Loginuser>(this.apiUrl + '/login',{headers}).pipe(
     map(
       userData => {
        sessionStorage.setItem('userid', userData.userId);
        console.log("============================= : " + userData);
        console.log('userData.roleId.roleId..'+userData.roleId);
        console.log('userData.roleId.m2mDbDefaultSearchDaysLimit..'+userData.m2mDbDefaultSearchDaysLimit);
        console.log('userData.m2mDbMaxRowsLimit..'+userData.m2mDbMaxRowsLimit);
        console.log('userData.m2mDbSearchKeyDaysLimit..'+userData.m2mDbSearchKeyDaysLimit);
        console.log('userDa role..'+userData.roleList[0].roleType);
        console.log(' userData.userId...'+ userData.userId);
        console.log('UserLocationDetails-------------------'+userData.userLocationList);        
        sessionStorage.setItem('globelUserId', '' + userData.userId);
        sessionStorage.setItem('roleId', '' + userData.roleId);
        sessionStorage.setItem('isPartner', '' + userData.isPartner);
        sessionStorage.setItem('userLocation', '' + userData.userLocationList);        
        
        if(userData.isPartner === 1){
        this.appSettingService.isPartner = true;
          } else {
        this.appSettingService.isPartner = false;
          }
        console.log(' this.appSettingService.isPartner..' + this.appSettingService.isPartner+"..."+userData.isPartner);

        sessionStorage.setItem('roleList', '' + userData.roleList);
        let authString = 'Basic ' + btoa(username + ':' + password);
        this.appSettingService.globelUserId = userData.userId;
        this.appSettingService.m2mDbDefaultSearchDaysLimit =  userData.m2mDbDefaultSearchDaysLimit;
        this.appSettingService.m2mDbMaxRowsLimit =  userData.m2mDbMaxRowsLimit;
        this.appSettingService.m2mDbSearchKeyDaysLimit =  userData.m2mDbSearchKeyDaysLimit;
        this.appSettingService.roleGlobelList = userData.roleList;
        this.appSettingService.userLocationList = userData.userLocationList;
        sessionStorage.setItem('basicauth', authString);
        sessionStorage.setItem('globalDateFormat', this.appSettingService.globelDatePickerInUSAFormat);
        return userData;
       }
     )

    );
  }


  logOut1(username, password) {
    const headers = new HttpHeaders({ Authorization: 'Basic ' + btoa(username + ':' + password) });


    return this.httpClient.get<Loginuser>(this.apiUrl + '/logout',{headers}).pipe(
     map(
       userData => {
        sessionStorage.setItem('username','');
        sessionStorage.setItem('userid','');


        sessionStorage.setItem('password', '');
        let authString = 'Basic ' + btoa(username + ':' + password);
        sessionStorage.setItem('basicauth', authString);
        return userData;
       }
     )

    );
  }


  isUserLoggedIn() {
    let user = sessionStorage.getItem('userid');
    return !(user === '');
  }
  forgotpassword(username){
    return this.httpClient.get<Enablesaveuseraccessdto>(this.apiUrl + '/forgotpassword?username=' + username);
  }


}
